(function () {
  'use strict';

  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  });

  var NAMES = { 1: 'face', 2: 'left side of head', 3: 'right side of head', 4: 'chest', 5: 'left side of body', 6: 'right side of body', 7: 'stomach' };
  document.querySelectorAll('[data-punch-picker]').forEach(function (root) {
    var mat = document.getElementById(root.getAttribute('data-mat'));
    var nameEl = root.querySelector('[data-picker-name]');
    var targetsEl = root.querySelector('[data-picker-targets]');
    var buttons = root.querySelectorAll('[data-punch]');
    function select(btn) {
      var zones = btn.getAttribute('data-zones').split(',');
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      if (mat) {
        mat.querySelectorAll('[data-zone]').forEach(function (z) {
          z.classList.toggle('is-dim', zones.indexOf(z.getAttribute('data-zone')) === -1);
        });
      }
      if (nameEl) nameEl.textContent = btn.getAttribute('data-punch') + ': ' + zones.join(' or ');
      if (targetsEl) targetsEl.textContent = 'Targets: ' + zones.map(function (n) { return NAMES[n] + ' (' + n + ')'; }).join(', ');
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    var start = root.querySelector('[data-punch][aria-pressed="true"]') || buttons[0];
    if (start) select(start);
  });

  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty'), 10));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    var t;
    cartForm.querySelectorAll('[data-autosubmit]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var u = cartForm.querySelector('[data-update-btn]');
          if (cartForm.requestSubmit && u) cartForm.requestSubmit(u); else if (u) u.click();
        }, 500);
      });
    });
  }

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-price-sticky]');
    var addBtns = [root.querySelector('[data-add]')].concat(Array.prototype.slice.call(document.querySelectorAll('.sticky-buy button')));
    var errorEl = root.querySelector('[data-form-error]');

    var mainImg = root.querySelector('[data-main-media] img');
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    root.querySelectorAll('input[name="dm-variant"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        idInput.value = radio.value;
        var compare = radio.getAttribute('data-compare');
        priceEl.innerHTML = radio.getAttribute('data-price') + (compare ? '<s>' + compare + '</s>' : '');
        if (stickyPrice) stickyPrice.innerHTML = radio.getAttribute('data-price');
        var ok = radio.getAttribute('data-available') === 'true';
        addBtns.forEach(function (b) { if (b) { b.disabled = !ok; } });
        if (root.querySelector('[data-add]')) root.querySelector('[data-add]').textContent = ok ? 'Add to basket' : 'Sold out';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      });
    });

    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var body = new FormData(form);
        var root2 = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        fetch(root2 + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to basket');
            window.location.href = root2 + 'cart';
          })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } });
      });
    }
  });
})();
